import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import angularFilter from "angular-filter";
import core from "../../core/core.module";
import mobiusHandler from "../mobius-handler";
import handlerForm from "../handler-form/handler-form";

angular
    .module('mobiusControl.mobiusHandlers', [angularUIB, mobiusHandler, core, handlerForm, angularFilter])
    .component('mobiusHandlers', {
        template: require('./mobius-handlers.html'),
        controller: ['MobiusHandler', 'notifier', '$uibModal', controller],
        bindings: {
            requests: '<',
            errorTypes: '<'
        }
    });

function controller(MobiusHandler, notifier, $uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.getList();
    };

    $ctrl.filterChanged = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilters = function () {
        $ctrl.currentPage = 1;
        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        MobiusHandler
            .getList({
                currentPage: $ctrl.currentPage,
                errorType: $ctrl.errorType,
                errorCode: $ctrl.errorCode,
                errorMessage: $ctrl.errorMessage,
                requestSlug: $ctrl.requestSlug
            })
            .then(
                function (response) {
                    $ctrl.handlers = response.data.handlers;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openForm = function (handler) {
        $uibModal
            .open({
                component: 'handlerForm',
                resolve: {
                    handler: function () {
                        return handler;
                    },
                    requests: function () {
                        return $ctrl.requests;
                    },
                    errorTypes: function () {
                        return $ctrl.errorTypes;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (handler) {
                        handler.errorType = result.errorType;
                        handler.errorCode = result.errorCode;
                        handler.errorMessage = result.errorMessage;
                        handler.requestSlug = result.requestSlug;
                        handler.message = result.message;
                    } else {
                        $ctrl.handlers.unshift(result);
                    }
                },
                function () {

                }
            );
    };

    $ctrl.deleteItem = function (handler, ind) {
        if (!confirm('Вы действительно хотите удалить обработчик?')) {
            return;
        }
        MobiusHandler.destroy(handler.id).then(
            function () {
                notifier.successNotify('Обработчик успешно удален');
                $ctrl.handlers.splice(ind, 1);
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        )
    };

}

export default "mobiusControl.mobiusHandlers"


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-handlers/mobius-handlers.js